module.exports = __webpack_public_path__ + "static/media/ShowAssignedRooms.bced1304.png";